export default __webpack_public_path__ + "static/media/code-03.d78deff8.svg";